<!-- TODO: Remove all fnd classes - this should only use emds classes-->
<div class="find-control-advanced">
  <div class="body-static">
    <div class="left-group">
      <button id="fnd-configuration-new" class="btn btn-light btn-flush-left"
      *ngIf="this.findControlDto?.SystemPermission.IsNewAllowed && !this.isNewButtonHidden" (click)="onNewClick()" translate>
        + New
      </button>
    </div>
    <div *ngIf="!loadingConfig && findControlDto" class="right-group">
      <mat-form-field class="quick-search mat-flush" appearance="outline">
        <input apAutoFocus matInput #input [formControl]="formControl" placeholder="Quick Search" type="text">
        <span matPrefix>
          <mat-icon (click)="onSearchClick()">search</mat-icon>
        </span>
      </mat-form-field>
      <div class="checkbox-group">
        <mat-checkbox [formControl]="inactiveCheckbox" >Include Inactive Items</mat-checkbox>
      </div>
    </div>
  </div>
  <div class="body-results">
    <div class="text-center" *ngIf="loadingData || loadingConfig">
      <ap-spinner size="3"></ap-spinner>
    </div>
    <div *ngIf="!loadingData && !loadingConfig">
      <ap-configurable-table [baseId]="tableBaseId" [tableId]="'find-table'" [clientColumnInfoList]="clientColumnInfoList"
        [serverColumnItemList]="serverColumnItemList" [dataItemList]="dataList" [setStickyHeaders]="true">
      </ap-configurable-table>
    </div>
  </div>
</div>
